import { take } from 'lodash';

const maxNumberOfStepImagePaths = 3;

// eslint-disable-next-line import/prefer-default-export
export const stepImages = (images) => take(images, maxNumberOfStepImagePaths);
